import { render, staticRenderFns } from "./OffersComponent.vue?vue&type=template&id=f87ef0e0&scoped=true"
import script from "./OffersComponent.vue?vue&type=script&lang=js"
export * from "./OffersComponent.vue?vue&type=script&lang=js"
import style0 from "./OffersComponent.vue?vue&type=style&index=0&id=f87ef0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87ef0e0",
  null
  
)

export default component.exports